export const MAX_VIDEO_DURATION_SECONDS = 120;
